import Input from 'lib/Input';
import usePendoTracking from 'customHooks/usePendoTracking';
import { FilterCreativeSetCodeProps } from './FilterCreativeSetCode.types';

const FilterCreativeSetCode: React.FC<FilterCreativeSetCodeProps> = ({ creativeSetCode = '', changeFilters }) => {
  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  return (
    <Input
      dataTestId="creative-set-code"
      name="creativeId"
      value={creativeSetCode}
      placeholder="Creative set code"
      onChange={(value: string) => changeFilters({ creativeSetCode: value })}
      debounceTime={1000}
      dataPendoId={getPendoDataId('Creative set code filter')}
    />
  );
};

export default FilterCreativeSetCode;
